{
    "cookie_consent_title": "Do you want to see this content?",
    "cookie_consent_button": "Open settings",
    "cookie_consent_description": {
        "type": "markdown",
        "value": "We need your consent to play this video."
    },
    "playVideo": "Play video",
    "hearVisualInterpretation": "Listen to the audio description track.",
    "doneVisualInterpretation": "Audio description is completed."
}
